import React from 'react'

export const HTMLContent = ({ content, className }) => {
  if(typeof content == "string")
    return (
      <div className={className} dangerouslySetInnerHTML={{ __html: content }} />
    )
  else
    return (
      <div className={className}>{content}</div>
    )
}



export default HTMLContent
